import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesSalesOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/SalesOrder/SalesOrderBrowser")
	}

	render() {
		return (
			<Activity 
				name="SalesSalesOrder"
				RenderedComponent={this.RenderedComponent}
				context="SalesSalesOrder"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesSalesOrderActivity)
